import { flowRight } from 'lodash/fp';
import PropTypes from 'prop-types';
import React from 'react';
import scrollToFirstError from 'components/form/scrollToFirstError';
import FormButtons from 'components/FormButtons';
import simulationLoader from '../../../simulationLoader';
import Header from '../Header';
import Form from '../Form';
import Operation from './Operation';
import PreviousDeficits from './PreviousDeficits';
import OtherLandRentalResults from './OtherLandRentalResults';
import Funding from './Funding';
import dataForm from './dataForm';

const ProductsInner = ({
    handleSubmit,
    params: { id, simulationId },
}) => (
    <Form handleSubmit={handleSubmit}>
        <div className="simulation-form-inner" id="simulationFormInner">
            <div className="container">
                <Header />
                <Operation />
                <Funding />
                <OtherLandRentalResults />
                <PreviousDeficits />
            </div>
        </div>
        <FormButtons
            back={`/rip/${id}/simulations/${simulationId}/overview`}
            list={`/rip/${id}/simulations/`}
        />
    </Form>
);

ProductsInner.propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    params: PropTypes.shape({
        id: PropTypes.string.isRequired,
        simulationId: PropTypes.string.isRequired,
    }).isRequired,
};

const Products = flowRight([
    simulationLoader,
    dataForm({
        form: 'simulation-product',
        id: ({ params: { simulationId } }) => simulationId,
        onSubmitSuccess: (result, dispatch, {
            navigate,
            params: { id, simulationId },
        }) => navigate(`/rip/${id}/simulations/${simulationId}/simulation`),
        onSubmitFail: scrollToFirstError({ containerId: 'simulationFormInner' }),
        type: 'simulation',
    }),
])(ProductsInner);

export default Products;
